import { render, staticRenderFns } from "./ShowRow.vue?vue&type=template&id=508e364b&lang=pug&"
import script from "./ShowRow.vue?vue&type=script&lang=js&"
export * from "./ShowRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports